import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["bubble"]

  connect() {
    this.boundClose = this.closeOnClickOutside.bind(this)
    this.boundEscape = this.closeOnEscape.bind(this)
    document.addEventListener("click", this.boundClose)
    document.addEventListener("keydown", this.boundEscape)
  }

  disconnect() {
    document.removeEventListener("click", this.boundClose)
    document.removeEventListener("keydown", this.boundEscape)
  }

  toggle() {
    this.bubbleTarget.classList.toggle("hidden")
  }

  close() {
    this.bubbleTarget.classList.add("hidden")
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
}
